var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8882)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1214 16.152L10.5417 15.6372C10.2518 15.3765 10.0282 15.0538 9.88737 14.6896L9.055 12.3931C8.9846 12.1986 9.07571 11.9834 9.26206 11.8965C9.36145 11.851 9.46083 11.8303 9.56436 11.8303C9.82525 11.8303 10.0779 11.9756 10.2062 12.2234L10.9682 13.7544C11.225 13.5641 11.374 13.262 11.374 12.9476V8.06893C11.374 7.72548 11.6515 7.44824 11.9952 7.44824C12.3389 7.44824 12.6164 7.72548 12.6164 8.06893V11.3793C12.6164 11.0358 12.8938 10.7586 13.2375 10.7586C13.5813 10.7586 13.8587 11.0358 13.8587 11.3793V11.5862C13.8587 11.2427 14.1362 10.9655 14.4799 10.9655C14.8236 10.9655 15.1011 11.2427 15.1011 11.5862V12C15.1011 11.6565 15.3785 11.3793 15.7222 11.3793C16.0659 11.3793 16.3434 11.6565 16.3434 12V15.3476C16.3434 15.6269 16.2593 15.8991 16.1057 16.13",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1214 16.152L10.5417 15.6372C10.2518 15.3765 10.0282 15.0538 9.88737 14.6896L9.055 12.3931C8.9846 12.1986 9.07571 11.9834 9.26206 11.8965C9.36145 11.851 9.46083 11.8303 9.56436 11.8303C9.82525 11.8303 10.0779 11.9756 10.2062 12.2234L10.9682 13.7544C11.225 13.5641 11.374 13.262 11.374 12.9476V8.06893C11.374 7.72548 11.6515 7.44824 11.9952 7.44824C12.3389 7.44824 12.6164 7.72548 12.6164 8.06893V11.3793C12.6164 11.0358 12.8938 10.7586 13.2375 10.7586C13.5813 10.7586 13.8587 11.0358 13.8587 11.3793V11.5862C13.8587 11.2427 14.1362 10.9655 14.4799 10.9655C14.8236 10.9655 15.1011 11.2427 15.1011 11.5862V12C15.1011 11.6565 15.3785 11.3793 15.7222 11.3793C16.0659 11.3793 16.3434 11.6565 16.3434 12V15.3476C16.3434 15.6269 16.2593 15.8991 16.1057 16.13",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1214 16.152L10.5417 15.6372C10.2518 15.3765 10.0282 15.0538 9.88737 14.6896L9.055 12.3931C8.9846 12.1986 9.07571 11.9834 9.26206 11.8965C9.36145 11.851 9.46083 11.8303 9.56436 11.8303C9.82525 11.8303 10.0779 11.9756 10.2062 12.2234L10.9682 13.7544C11.225 13.5641 11.374 13.262 11.374 12.9476V8.06893C11.374 7.72548 11.6515 7.44824 11.9952 7.44824C12.3389 7.44824 12.6164 7.72548 12.6164 8.06893V11.3793C12.6164 11.0358 12.8938 10.7586 13.2375 10.7586C13.5813 10.7586 13.8587 11.0358 13.8587 11.3793V11.5862C13.8587 11.2427 14.1362 10.9655 14.4799 10.9655C14.8236 10.9655 15.1011 11.2427 15.1011 11.5862V12C15.1011 11.6565 15.3785 11.3793 15.7222 11.3793C16.0659 11.3793 16.3434 11.6565 16.3434 12V15.3476C16.3434 15.6269 16.2593 15.8991 16.1057 16.13",
    stroke: "white",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.959 18.0002V16.7588H16.3425V18.0002",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.959 18.0002V16.7588H16.3425V18.0002",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70755 7.67206C9.71377 7.73412 9.71708 7.79785 9.71708 7.86199C9.71708 8.88778 8.88513 9.71909 7.85854 9.71909C6.83195 9.71909 6 8.88778 6 7.86199C6 6.83619 6.83237 6.00488 7.85854 6.00488C8.18693 6.00488 8.49586 6.09054 8.76379 6.23992",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70755 7.67206C9.71377 7.73412 9.71708 7.79785 9.71708 7.86199C9.71708 8.88778 8.88513 9.71909 7.85854 9.71909C6.83195 9.71909 6 8.88778 6 7.86199C6 6.83619 6.83237 6.00488 7.85854 6.00488C8.18693 6.00488 8.49586 6.09054 8.76379 6.23992",
    stroke: "#A2A2A2",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63914 6.55518L7.85804 8.3349L7 7.47752",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63914 6.55518L7.85804 8.3349L7 7.47752",
    stroke: "#A2A2A2",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1369 9.72414C17.1661 9.72414 18.0005 8.89046 18.0005 7.86207C18.0005 6.83368 17.1661 6 16.1369 6C15.1078 6 14.2734 6.83368 14.2734 7.86207C14.2734 8.89046 15.1078 9.72414 16.1369 9.72414Z",
    fill: "white",
    stroke: "#A2A2A2",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.756 8.48308L15.5137 7.2417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.756 8.48308L15.5137 7.2417",
    stroke: "#A2A2A2",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.756 7.2417L15.5137 8.48308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.756 7.2417L15.5137 8.48308",
    stroke: "#A2A2A2",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8882",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/Approval.340e9130c83b42525bf463c770eced36.svg";
export { ForwardRef as ReactComponent };